import React, { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";

import Pagination from "../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { convertStringToArray, extractDate } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import PhotoGalleryCoverCard from "../Home/PhotoVideoPublication/Photos/PhotoGalleryCoverCard";
import Loader from "../../components/Loader";
import usePagination from "../../hooks/usePagination";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { Link, useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const PhotoGalleryArchiveDetailPage = () => {
  const { getText } = useLanguageTranslation();
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: photosGalleryData = [], isLoading: photosGalleryIsLoading } =
    useGetProtectedApiDataQuery({
      url: "photo_gallery_archive",
      lang: languageType,
    });

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(photosGalleryData, 12);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(photosGalleryData?.[0]);
  }, [photosGalleryData]);

  if (photosGalleryIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        titleLink="/publication-detail"
        levelTwo={false}
        levelThree={false}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <>
                <div className="row">
                  {currentItems.map((item, key) => (
                    <div
                      className="col-12 col-sm-12 col-md-3 col-lg-3"
                      key={key}
                    >
                      <div className="gallery-card">
                        <div className="crd-title">
                          <p className="title-txt">{item.title}</p>
                        </div>
                        <div className="card-imgs">
                          {convertStringToArray(
                            item.field_mulitple_photo_upload,
                          )
                            .slice(0, 2)
                            .map((photo, i) => (
                              <img
                                key={i}
                                src={`${process.env.REACT_APP_IMAGE_URL}${photo?.file_path}`}
                                alt={`${
                                  item.title ||
                                  getText("Photo gallery", "फोटो गैलरी")
                                } ${getText("photo", "फोटो")} ${i + 1}`}
                              />
                            ))}
                        </div>
                        <div className="card-buttons">
                          <Link
                            to={`/archive-photo-gallery-detail/${item.nid}`}
                            className="quick-btn"
                          >
                            {getText("View More", "और देखो")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="mt-4">
                    <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
                  </div>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryArchiveDetailPage;
